import { FC } from "react";
import { ForgotPasswordWidget } from "../../widgets/forgot-password/ForgotPassword";

interface Props {
  onContinue: () => void;
}

export const ForgotPasswordPage: FC<Props> = ({ onContinue }) => {
  return <ForgotPasswordWidget onContinue={onContinue} />;
};
